module.exports = __webpack_public_path__ + "img/expand.840880f0.svg";